// Centralized icon paths for reuse across the app
// These reference files located in `public/icons/`

export const ICONS = {
  alertsInstantanees: "/icons/Alertes instantanées icon.svg",
  analyseTempsReel: "/icons/Analyse en temps réel icon.svg",
  definition: "/icons/Définition icon.svg",
  fonctionnalite: "/icons/Fonctionnalité icon.svg",
  importance: "/icons/Importance icon.svg",
  reductionDesPertes: "/icons/Réduction des pertes icon.svg",
  scalabilite: "/icons/Scalabilité icon.svg",
  securiteProactive: "/icons/Sécurité proactive icon.svg",
  traitementAvance: "/icons/Traitement avancé icon.svg",
  fightDetection: "/icons/fight detection icon.svg",
  knifeDetection: "/icons/knife detection icon.svg",
  twentyFourSevenMonitoring: "/icons/24-7 montoring.svg",
  twentyFourSevenProtection: "/icons/24-7 protection.svg",
  reduceDamage: "/icons/Reduce damage.svg",
  alwaysConnectedAlwaysOptimised: "/icons/always connected always optimised.svg",
  bankSecurity: "/icons/bank-security.svg",
  comprehensiveThreatDetection: "/icons/comrehensive threat detection.svg",
  earlyDetection: "/icons/early detection.svg",
  easyIntegration: "/icons/easy integration.svg",
  easyInterrogation: "/icons/easy interrogation.svg",
  enhanceSafety: "/icons/enhance safety.svg",
  enhancedSituationalAwareness: "/icons/enhanced situ awareness.svg",
  fastResponseTime: "/icons/fast-response time.svg",
  immediateAssistance: "/icons/immediate assitance.svg",
  increasedAccuracy: "/icons/increased accuracy.svg",
  increaseSafety: "/icons/inscrease safety.svg",
  lakkSecurity: "/icons/lakk security.svg",
  minimalFalseAlarm: "/icons/minimal false alarm.svg",
  movementRecognition: "/icons/movement regonition.svg",
  nonIntrusiveMonitoring: "/icons/non enstrutive monotoring.svg",
  onePlugFullControl: "/icons/one pliug full control.svg",
  pharmacySecurity: "/icons/pharmacy security.svg",
  preventionBeforeEscalation: "/icons/prevention befiore esacalion.svg",
  proactivePrevention: "/icons/proactive prevention.svg",
  proactiveTheftPrevention: "/icons/proatctive theft provetion.svg",
  realTimeAction: "/icons/real-time action.svg",
  reducedResponseTime: "/icons/reduced response time.svg",
  schoolSecurity: "/icons/school security.svg",
  seamlessIntegration: "/icons/seamless integration.svg",
  securityYouCanTrust: "/icons/security you can trust.svg",
  suspiciousMovementDetection: "/icons/suspicious mouvement detection.svg",
  unlimitedDeviceOneGateway: "/icons/unlimited device one gateway.svg",
  upTo98PercentAlarmReduction: "/icons/up to 98 alarm reduction.svg",
  vapeCigaretteOrPuff: "/icons/vape ciarette or puff.svg",
  motionRecognition: "/icons/motion recognition.svg",
  darkModeWhite: "/icons/dark mode white.svg",
  lightModeWhite: "/icons/light mode white.svg",
} as const;

export type IconKey = keyof typeof ICONS;

export function getIcon(key: IconKey): string {
  return ICONS[key];
}

// Optional: typed list of all keys (useful for selects, previews, etc.)
export const ICON_KEYS: IconKey[] = Object.keys(ICONS) as IconKey[];

// Small helper React-like usage example (no import side-effects):
// <img src={getIcon('alertsInstantanees')} alt="Alertes instantanées" />
